import {Component, OnInit} from '@angular/core';
import {CheckboxModule} from "primeng/checkbox";
import {DateTextPipe} from "../../pips/date-text.pipe";
import {NumberTextPipe} from "../../pips/number-text.pipe";
import {SharedModule} from "primeng/api";
import {Table, TableModule} from "primeng/table";
import {locale} from "moment";
import {Attribute} from "../../dto/Attribute";
import {AdminTemplateComponent} from "../admin-template/admin-template.component";
import {AdminEditPageComponent} from "../admin-edit-page/admin-edit-page.component";
import {NgIf} from "@angular/common";
import {DialogModule} from "primeng/dialog";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-admin-attributes',
  standalone: true,
  imports: [
    CheckboxModule,
    DateTextPipe,
    NumberTextPipe,
    SharedModule,
    TableModule,
    AdminEditPageComponent,
    NgIf,
    DialogModule,
    FormsModule
  ],
  templateUrl: './admin-attributes.component.html',
  styleUrl: './admin-attributes.component.css'
})
export class AdminAttributesComponent extends AdminTemplateComponent implements OnInit{

  listAttribute: Array<Attribute> = new Array<Attribute>();
  totalAttribute:number= 0;
  selectedAttribute:Attribute= new Attribute();
  displayEdit:boolean=false;
  ngOnInit() {

  }

  loadListAttribute(table: Table) {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("lnd/attribute/get_attribute_list?" +
        "page=" + (table != null ? table.first / 10 : 0) +
        "&nrpp=" + (table != null && table.rows ? table.rows : 10)+
        "&type=SUCCESS_STORY" );
    observable.subscribe({
      next: (res: string) => {
        if (res["status"] == 200) {
          this.listAttribute = res["entity"];
          this.totalAttribute = res["total"];

        }
        if (res["status"] == 401) {
          this.gotoLogin();
        }
        return res;
      },
      error: (e) => {
        this.messageService.clear();
        this.messageService.add({
              severity: 'error',
              summary: $localize`:@@Error:Error`,
              detail: $localize`:@@Server Timout Det:Server Timout Det`
            }
        );
      },
      complete:()=>{
        this.global.progressBar = false;
      }
    });
  }

  newAttribute(){
    this.selectedAttribute= new Attribute();
    this.displayEdit = true;
  }
  editAttribute(attr: any) {
    this.selectedAttribute= attr;
    this.displayEdit = true;

  }
  savaAttribute(tbl){
    let params = {};
    let body = this.selectedAttribute;
    this.global.progressBar = true;
    var observable = this.restBack.doPost("lnd/attribute/save_attribute", body, params);
    observable.then((res: string) => {
          if (res["status"] == 200) {
            let o = res["entity"];
            // this.loadIndexData(null);
            this.loadListAttribute(tbl)
            this.messageService.clear();
            this.messageService.add({
              severity: 'info',
              summary: $localize`:@@Save_Success:Save Success`,
              detail: $localize`:@@Save_Success_Det:Save_Success_Det`
            });

          } else if (res["status"] == 400) {
            if (res["message"] == "ConflictPageName") {
              this.messageService.clear();
              this.messageService.add({
                severity: 'error',
                summary: $localize`:@@Error:Error`,
                detail: $localize`:@@Conflict Page Name:Conflict Page Name`,
                life: 6000
              });
            }
          } else if (res["status"] == 401) {

          }
          return res;
        },
        error => {
          this.messageService.clear();
          this.messageService.add({
                severity: 'error',
                summary: $localize`:@@Error:Error`,
                detail: $localize`:@@Server Timout Det:Server Timout Det`
              }
          );
        }).finally(() => {
          this.displayEdit = false;
      this.global.progressBar = false;

    });
  }

  deleteAttribute(attr: Attribute, dt: Table) {
    this.confirmationService.confirm({
      message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
      header: $localize`:@@Delete:Delete`,
      acceptLabel: $localize`:@@Yes:Yes`,
      rejectLabel: $localize`:@@No:No`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("lnd/attribute/delete_attribute?" +
            "id=" + attr.id);
        observable.subscribe({
          next: (res: string) => {
            if (res["status"] == 200) {
              this.messageService.clear();
              this.messageService.add({
                    severity: 'info',
                    summary: $localize`:@@Delete:Delete`,
                    detail: $localize`:@@Delete Success:Delete Success`
                  }
              );
              this.loadListAttribute(dt);
            }
            if (res["status"] == 401) {
              this.gotoLogin();
            }
            return res;
          },
          error: (e) => {
            this.messageService.clear();
            this.messageService.add({
                  severity: 'error',
                  summary: $localize`:@@Error:Error`,
                  detail: $localize`:@@Server Timout Det:Server Timout Det`
                }
            );
          },
          complete: () => {
            this.global.progressBar = false;
          }
        });
      }
    });
  }
}
